import {
  type AddIdeaToQueryAction,
  AddItemType,
  BulkLoadedType,
  BulkRemoveType,
  ErrorType,
  InvalidateType,
  LoadedMoreType,
  LoadedType,
  type QueryParams,
  RequestMoreType,
  RequestType,
} from 'common/actions/ideaQueries';

import queryReducerFactory, { type QueriesState, type QueryState } from './queryReducerFactory';

export { defaultState } from './queryReducerFactory';

import type { LoadedAction, QueryAction } from 'common/actions/queryActionFactory';
import type { Idea, IdeaIDOnly } from 'common/api/endpoints/idea';

export type IdeaIDQueriesState = QueriesState<IdeaIDOnly, QueryParams>;
export type IdeaIDQueryState = QueryState<IdeaIDOnly, QueryParams> | undefined;
export type IdeaQueryState = QueryState<Idea, QueryParams> | undefined;

const queryReducer = queryReducerFactory<IdeaIDOnly, QueryParams>({
  bulkLoadedType: BulkLoadedType,
  bulkRemoveType: BulkRemoveType,
  errorType: ErrorType,
  invalidateType: InvalidateType,
  loadedMoreType: LoadedMoreType,
  loadedType: LoadedType,
  requestMoreType: RequestMoreType,
  requestType: RequestType,
});

export default function reducer(
  state: IdeaIDQueriesState,
  action: QueryAction<IdeaIDOnly, QueryParams> | AddIdeaToQueryAction,
) {
  switch (action.type) {
    case AddItemType: {
      const addItemAction = action as AddIdeaToQueryAction;
      const existingQuery = state[addItemAction.queryKey];

      if (!existingQuery) {
        return state;
      }

      const existingItems = existingQuery.items || [];
      const itemExists = existingItems.some((item) => item._id === addItemAction.item._id);

      if (itemExists) {
        return state;
      }

      return {
        ...state,
        [addItemAction.queryKey]: {
          ...existingQuery,
          items: addItemAction.sortedIdeaIDs.map((id) => ({ _id: id })),
          lastUpdated: addItemAction.timestamp,
        },
      };
    }
    default: {
      let actionToUse = action as QueryAction<IdeaIDOnly, QueryParams>;
      if (action.type === LoadedMoreType || action.type === LoadedType) {
        const loadedAction = actionToUse as LoadedAction<IdeaIDOnly, QueryParams>;
        actionToUse = {
          ...loadedAction,
          items: loadedAction.items.map((item) => {
            return {
              _id: item._id,
            };
          }),
        };
      }

      return queryReducer(state, actionToUse);
    }
  }
}
